import { useCallback, useState } from 'react'
import { SUPPLIER_GROUP_FOLD_KEY } from '../constants/supplierChanges'

/**
 * The suppliers whose groups are folded in "Supplier changes to review",
 * kept for the visit (sessionStorage) and shared by the list and the order
 * page's rail, as in the mock's Option J.
 */
export function useFoldedSuppliers() {
  const [folded, setFolded] = useState<Set<string>>(() => {
    try {
      return new Set(JSON.parse(window.sessionStorage.getItem(SUPPLIER_GROUP_FOLD_KEY) ?? '[]') as string[])
    } catch {
      return new Set()
    }
  })
  const toggle = useCallback((key: string) => {
    setFolded((current) => {
      const next = new Set(current)
      if (next.has(key)) next.delete(key)
      else next.add(key)
      try {
        window.sessionStorage.setItem(SUPPLIER_GROUP_FOLD_KEY, JSON.stringify([...next]))
      } catch {
        // Storage blocked: the fold lasts until the page is left.
      }
      return next
    })
  }, [])
  return { folded, toggle }
}
